import {
  Component,
  HostListener,
  ChangeDetectorRef,
  OnInit,
  Inject,
  APP_INITIALIZER,
  ApplicationInitStatus,
  Renderer2,
} from "@angular/core";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { AlertController, NavController, Platform } from "@ionic/angular";
import { ToolsService } from "./services/tools.service";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
// import { NavigationService } from './services/navigation.service';
import { StatisticsService } from "src/app/services/statistics.service";
import { RestService } from "./services/rest.service";
import { Config } from "./interfaces/myCustomRoute.interface";
import { ScriptService } from "./services/chatbot.service";
import { fromEvent, map, merge, of } from "rxjs";
import QRCode from "qrcode";
import { NavigationService } from "./services/navigation.service";
import { AnimationService } from "./services/animation.service";
import { SlidesService } from "./kiosk/slides/slides.service";
import { ChatbotBridgeService } from "./services/chatbot-bridge.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  idleState = "NOT_STARTED";
  countdown?: number = null;
  lastPing?: Date = null;
  idleTime: any;
  qr: any;

  @HostListener("document:contextmenu", ["$event"])
  disableRightClick(event: MouseEvent) {
    if (this.tools.reelsPreviewMode || this.tools.reelsMode) return;

    event.preventDefault();
  }

  constructor(
    keepalive: Keepalive,
    cd: ChangeDetectorRef,
    @Inject(APP_INITIALIZER) public appInit: ApplicationInitStatus,
    public platform: Platform,
    private translate: TranslateService,
    private router: Router,
    public tools: ToolsService,
    private idle: Idle,
    public navCtrl: NavController,
    public stats: StatisticsService,
    public rest: RestService,
    public route: ActivatedRoute,
    public alertController: AlertController,
    private renderer: Renderer2,
    public navigation: NavigationService,
    public animationService: AnimationService,
    private scriptService: ScriptService,
    private slidesService: SlidesService,
    private chatbotBridge: ChatbotBridgeService,
  ) {
    //TOTEM CONFIG
    this.rest.config = {
      standBy: true,
      kioskMode: true,
      keyBoardOnScreen: true,
      techMode: false,
    };
    this.stats.initStats();
    idle.setIdle(5); // how long can they be inactive before considered idle, in seconds
    idle.setTimeout(120); // how long can they be idle before considered timed out, in seconds
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active
    // do something when the user becomes idle
    idle.onIdleStart.subscribe(() => {
      this.idleState = "IDLE";
    });
    // do something when the user is no longer idle
    idle.onIdleEnd.subscribe(() => {
      console.log(`${this.idleState} ${new Date()}`);
      this.idleState = "NOT_IDLE";
      this.countdown = null;
      cd.detectChanges();
    });
    // do something when the user has timed out
    idle.onTimeout.subscribe(() => {
      this.goStandBy();
    });
    // do something as the timeout countdown does its thing
    idle.onTimeoutWarning.subscribe((seconds) => (this.countdown = seconds));
    // set keepalive parameters, omit if not using keepalive
    keepalive.interval(15); // will ping at this interval while not idle, in seconds
    keepalive.onPing.subscribe(() => (this.lastPing = new Date())); // do something when it pings

    this.navigation.startSaveHistory();
    this.translate.setDefaultLang("es");
    this.translate.use("es");
    this.rest.redirectPage = "/home-kiosk";
    this.tools.setCorporiveColors();
  }

  get standByRoute() {
    return this.router.url.includes("slides");
  }

  get kioskRoute() {
    return this.router.url.includes("home-kiosk");
  }

  get licenseRoute() {
    return this.router.url.includes("license");
  }

  checkHeader() {
    return !(
      this.router.url.includes("slides") || this.router.url.includes("license")
    );
  }

  ngOnInit() {
    this.checkNetworkStatus();
    this.chatbotBridge.init();
    window.addEventListener("load", function () {
      document.querySelector('link[rel="manifest"]')?.remove();
    });
  }

  resetTimeout() {
    this.stats.sumClicks();
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }

  async goStandBy() {
    console.log("TIMED OUT!!!");
    this.tools.closeAllModals();
    this.chatbotBridge.setStandby(true);
    this.stats.setSesh(); //SEND STATS
    this.animationService.setAnimationType("fadeAnimation");
    this.rest.setDefaultDeviceSettings();
    this.rest.setDefaultCiceroneData();
    this.rest.ciceroneData.interestPoints = this.tools.sortPointsPerDistance(
      this.rest.ciceroneData.interestPoints,
      this.rest.device.location,
    );
    this.tools.setCorporiveColors();
    if (
      this.rest?.config?.standBy &&
      this.rest?.device?.reels?.items?.data?.length > 0
    ) {
      await this.slidesService.setSlides();
      if (this.slidesService.filteredGrids?.length === 0) {
        this.idle.watch();
        this.router.navigate([this.rest.redirectPage]);
        return;
      }
      this.router.navigate(["/slides/0"]);
    } else {
      this.idle.watch();
      this.router.navigate([this.rest.redirectPage]);
    }
  }

  checkNetworkStatus() {
    this.rest.networkStatus = navigator.onLine;
    this.rest.networkStatus$ = merge(
      of(null),
      fromEvent(window, "online"),
      fromEvent(window, "offline"),
    )
      .pipe(map(() => navigator.onLine))
      .subscribe((status) => {
        console.log("Internet Connection:", status);
        this.rest.networkStatus = status;
      });
  }

  //Presentar QR de abajo
  async presentAlert() {
    this.makeQRCode();
    const textQR = this.translate.instant("Chatea con nosotros");
    const alert = await this.alertController.create({
      cssClass: "modalAlerts",
      header: textQR,
      message: `<img src="${this.qr}" style="border-radius: 2px">`,
    });

    await alert.present();
    this.tools.arrayModals.push(alert);
    setTimeout(() => {
      alert.dismiss();
    }, 30000);
    const { role } = await alert.onDidDismiss();
  }

  //QR para poder acceder a la web
  makeQRCode() {
    const qrcode = QRCode;
    const self = this;
    qrcode.toDataURL(
      `${environment.publicWebUrl}/?mac=${this.rest.device.mac}`,
      { errorCorrectionLevel: "H" },
      function (err, url) {
        self.qr = url;
      },
    );
  }

  prepareRoute(outlet: RouterOutlet) {
    const animationData =
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"];
    return animationData
      ? `${animationData}-${outlet.activatedRoute.snapshot.params["id"]}`
      : "";
  }

  getAnimation() {
    return this.animationService.getAnimation();
  }

  goBack() {
    if (this.router.url != this.rest.redirectPage) {
      // history.back()
      this.animationService.setAnimationType("slideInvertedAnimation");
      setTimeout(() => {
        this.navigation.goBack();
      }, 15);
    }
  }
}
